import { Range, Transaction } from 'types';
import transactionTypes from 'constants/transactionTypes';
import { createTransaction } from 'modules/transactions/utils/createTransaction';

type GetTransactionsProps = {
  ranges: Range[];
  partnerSellerId: string;
  partnerBuyerId: string;
  holdingClassId: string;
  sharePrice: number;
};

export const getTransactions = ({
  ranges,
  partnerSellerId,
  partnerBuyerId,
  holdingClassId,
  sharePrice,
}: GetTransactionsProps): Transaction[] => {
  const transactions: Transaction[] = [];

  ranges.forEach((range: Range) => {
    const newTransactionSell = createTransaction({
      range: {
        from: range.from,
        to: range.to,
        partner: partnerSellerId,
        shareClass: holdingClassId,
        sharePrice,
      },
      transactionType: transactionTypes.SELL,
    }) as Transaction;

    const newTransactionBuy = createTransaction({
      range: {
        from: range.from,
        to: range.to,
        partner: partnerBuyerId,
        shareClass: holdingClassId,
        sharePrice,
      },
      transactionType: transactionTypes.BUY,
    }) as Transaction;

    transactions.push(newTransactionSell);
    transactions.push(newTransactionBuy);
  });

  return transactions;
};
